import { gql } from '@apollo/client';

export const CHANGE_PASSWORD = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
        changePassword(input: $input) {
            success
            message
        }
    }
`;

export interface ChangePasswordInput {
    countryCode: number;
    phone: string;
    newPassword: string;
    verificationCode: string;
    /** 改密验证码校验通过时下发的一次性 token */
    changePasswordToken?: string | null;
}

export interface ChangePasswordResponse {
    changePassword: {
        success: boolean;
        message: string;
    };
}

export interface ChangePasswordVariables {
    input: ChangePasswordInput;
}

